var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"title":"Nueva cita","hide-footer":""}},[_c('p',[_vm._v("This is a sample")])])
}
var staticRenderFns = []

export { render, staticRenderFns }